import {
  ADD_NEW_HYPERLINK_REQUESTED,
  CLEAR_HYPERLINK,
  GET_HYPERLINK_BY_ID_REQUESTED,
} from './actionTypes';

export const getHyperlinkById = (uuid, locale, token) => ({
  type: GET_HYPERLINK_BY_ID_REQUESTED,
  payload: {
    uuid,
    locale,
    token,
  },
});

export const addNewHyperlink = (data) => ({
  type: ADD_NEW_HYPERLINK_REQUESTED,
  payload: {
    data,
  },
});

export const clearHyperLink = () => ({
  type: CLEAR_HYPERLINK,
});
